<template>
<!--  <div class="login_container">-->
<!--    <div class="login_box">-->
<!--      &lt;!&ndash; 头像区 &ndash;&gt;-->
<!--      <div class="avatar_box">-->
<!--        <img src="../assets/logo.png" alt="avatar" />-->
<!--      </div>-->
<!--      &lt;!&ndash; 登录表单 &ndash;&gt;-->
<!--      <div>-->
<!--        <el-form-->
<!--          ref="loginFormRef"-->
<!--          :model="loginForm"-->
<!--          :rules="loginFormRules"-->
<!--          :hide-required-asterisk = true-->
<!--          label-width="60px"-->
<!--          class="login_form">-->
<!--          <el-form-item label="账号" prop="account">-->
<!--            <el-input v-model="loginForm.account" prefix-icon="iconfont icon-user"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="密码" prop="password">-->
<!--            <el-input-->
<!--              v-model="loginForm.password"-->
<!--              type="password"-->
<!--              prefix-icon="iconfont icon-3702mima"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item class="btns">-->
<!--            <el-button type="primary" @click="login">登录</el-button>-->
<!--            <el-button type="info" @click="resetLoginForm">重置</el-button>-->
<!--          </el-form-item>-->
<!--        </el-form>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->


  <div class="site-wrapper site-page--login">
    <div class="site-content__wrapper">
      <div class="site-content">
        <div class="brand-info">
          <h2 class="brand-info__text">薪资查询助手</h2>
          <p class="brand-info__intro"> Excel自动生成工资条，一键群发。无需固定模板，简单易用的工资条</p>

        </div>



<!--        <div style="margin-top: 33%">-->

<!--          v..1.2-->
<!--        </div>-->


        <div class="login-main">




          <!--     用户登录     -->


          <div v-if="switchShow == 1">

            <el-tabs v-model="activeName" >
              <el-tab-pane label="密码登录" name="first">
                <h3 class="login-title">管理员登录</h3>
                <el-form :model="loginForm"  ref="loginFormRef" @keyup.enter.native="login" status-icon>
                  <el-form-item prop="userName">
                    <el-input v-model="loginForm.account" placeholder="帐号" prefix-icon="iconfont icon-user"></el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input v-model="loginForm.password" type="password" placeholder="密码" prefix-icon="iconfont icon-3702mima"></el-input>
                  </el-form-item>


                  <el-row :gutter="20">
                    <el-col :span="16"  :offset="16">
                      <el-link type="primary" @click="switchShow = 2" target="_blank">注册新用户</el-link>
                      <el-link class="forgetPassword"   type="primary"  @click="switchShow = 3"target="_blank">忘记密码</el-link>
                    </el-col>
                  </el-row>

                  <el-form-item>
                    <el-button class="login-btn-submit" type="primary" @click="login">登录</el-button>
                  </el-form-item>

                </el-form>
              </el-tab-pane>


              <el-tab-pane label="短信免密登录" name="second">
                <h3 class="login-title">短信免密登录</h3>
                <el-form :model="loginForm" ref="loginFormRef" @keyup.enter.native="login" status-icon>
                  <el-form-item prop="userName">
                    <el-input v-model="loginForm.account" placeholder="帐号" prefix-icon="el-icon-mobile-phone"></el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input v-model="loginForm.smsCode" style="width: 40%" placeholder="验证码"  prefix-icon="el-icon-key" ></el-input>
                    <el-button type="primary" :disabled='isDisabled' @click="sendCode(1)">{{buttonText}}</el-button>
                  </el-form-item>


                  <el-row :gutter="20">
                    <el-col :span="16"  :offset="16">
                      <el-link type="primary" @click="switchShow = 2" target="_blank">注册新用户</el-link>
                      <el-link class="forgetPassword"   type="primary"  @click="switchShow = 3"target="_blank">忘记密码</el-link>
                    </el-col>
                  </el-row>

                  <el-form-item>
                    <el-button class="login-btn-submit" type="primary" @click="phoneLogin">短信免密登录</el-button>
                  </el-form-item>

                </el-form>

              </el-tab-pane>
            </el-tabs>


          </div>



          <!--     新用户注册页面     -->

          <div v-if="switchShow == 2">
            <h3 class="login-title">新用户注册</h3>
            <el-form :model="registerForm"  ref="loginFormRef" @keyup.enter.native="login" status-icon>
              <el-form-item prop="userName">
                <el-input v-model="registerForm.account" placeholder="手机号" prefix-icon="el-icon-mobile-phone"></el-input>
              </el-form-item>

              <el-form-item prop="userName">
                <el-input v-model="registerForm.password"  type="password" placeholder="密码" prefix-icon="el-icon-lock"></el-input>
              </el-form-item>

              <el-form-item prop="userName">
                <el-input v-model="registerForm.companyName" placeholder="企业名称" prefix-icon="el-icon-place"></el-input>
              </el-form-item>


              <el-form-item prop="password">
                <el-input v-model="registerForm.smsCode" style="width: 40%" placeholder="验证码"  prefix-icon="el-icon-key" ></el-input>
                <el-button type="primary" :disabled='isDisabled' @click="sendCode(2)">{{buttonText}}</el-button>
              </el-form-item>



              <el-row :gutter="20">
                <el-col :span="16"  :offset="16">
                  <el-link type="primary" @click="switchShow = 1" target="_blank">已有账号?立即登录</el-link>
                </el-col>
              </el-row>

              <el-form-item>
                <el-button class="login-btn-submit" type="primary" @click="adminRegister">注册</el-button>
              </el-form-item>

            </el-form>
          </div>



          <!--     用户忘记密码    -->

          <div v-if="switchShow == 3">
            <h3 class="login-title">忘记密码</h3>
            <el-form :model="forgetPasswordForm"  ref="loginFormRef" @keyup.enter.native="login" status-icon>
              <el-form-item prop="userName">
                <el-input v-model="forgetPasswordForm.account" placeholder="帐号" prefix-icon="el-icon-mobile-phone"></el-input>
              </el-form-item>
              <el-form-item prop="userName">
                <el-input v-model="forgetPasswordForm.password"  type="password" placeholder="修改密码" prefix-icon="el-icon-lock"></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="forgetPasswordForm.smsCode" style="width: 40%" placeholder="验证码"  prefix-icon="el-icon-key" ></el-input>
                <el-button type="primary" :disabled='isDisabled' @click="sendCode(3)">{{buttonText}}</el-button>
              </el-form-item>

              <el-row :gutter="20">
                <el-col :span="16"  :offset="16">
                  <el-link type="primary" @click="switchShow = 1" target="_blank">已有账号?立即登录</el-link>
                </el-col>
              </el-row>

              <el-form-item>
                <el-button class="login-btn-submit" type="primary" @click="forgetPasswordLogin">修改密码并登陆</el-button>
              </el-form-item>

            </el-form>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  data () {
    return {
      loginForm: {
        account: '',
        password: '',
        smsCode:"",
      },
      registerForm:{
        account:"",
        password: "",
        smsCode:""
      },
      forgetPasswordForm:{
        account:"",
        password: "",
        smsCode:""
      },
      activeName: 'first',
      registerDialogFormVisible:false,
      buttonText: '发送验证码',


      isDisabled: false, // 是否禁止点击发送验证码按钮
      flag: true,
      switchShow:1  //1是登录页  2是注册页   3是忘记密码页
    }
  },
  methods: {
    login () {
      // 表单预验证
      // valid：bool类型
      this.$refs.loginFormRef.validate(async valid => {
        // console.log(valid)
        if (!valid) return false
        // this.$http.post('login', this.loginForm): 返回值为promise
        // 返回值为promise，可加await简化操作 相应的也要加async

        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        setTimeout(() => {
          loading.close();
        }, 5000);


        const { data: res } = await this.$http.post('login/adminLogin', this.loginForm)
        loading.close();
        if (res.code !== '10000') return this.$message.error(res.msg)
        this.$message.success('登录成功')
        // 1、将登陆成功之后的token, 保存到客户端的sessionStorage中; localStorage中是持久化的保存
        //   1.1 项目中出现了登录之外的其他API接口，必须在登陆之后才能访问
        //   1.2 token 只应在当前网站打开期间生效，所以将token保存在sessionStorage中
        // console.log(res);
        window.localStorage.setItem('token', res.data.token);
        window.localStorage.setItem('company', JSON.stringify(res.data));
        // 2、通过编程式导航跳转到后台主页, 路由地址为：/home

        this.$router.push('/home')
      })
    },
    //type 1是登录  2是注册  3是忘记密码
    async sendCode(type) {
      let sendForm = {};
      let phone = '';
      switch (type) {
        case 1:
          //登录发送短信
          phone = this.loginForm.account;
          sendForm.phone = phone;
          sendForm.sendType = 1;
          break;
        case 2:
          //注册用户发送短信
          phone = this.registerForm.account;
          sendForm.phone = phone;
          sendForm.sendType = 1;
          break;
        case 3:
          //忘记密码发送短信
          phone = this.forgetPasswordForm.account;
          sendForm.phone = phone;
          sendForm.sendType = 1;
          break;
        default:
          return ;
      }


      let reg = /^1[0-9]{10}$/;
      if ((!reg.test(phone)) || phone == '' || phone == "") {
        this.$message({
          message: '手机号格式错误',
          type: 'warning'
        });

        return ;
      }

      const {data: res} = await this.$http.post('/sms/sendSmsCode', sendForm);

      if (res.code == '10000') {
        let time = 60
        this.buttonText = '已发送'
        this.isDisabled = true
        if (this.flag) {
          this.flag = false;
          let timer = setInterval(() => {
            time--;
            this.buttonText = time + ' 秒'
            if (time === 0) {
              clearInterval(timer);
              this.buttonText = '重新获取'
              this.isDisabled = false
              this.flag = true;
            }
          }, 1000)
        }
      }
    },
    async phoneLogin(){

      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });


      const { data: res } = await this.$http.post('login/adminPhoneLogin', this.loginForm)
      loading.close();
      if (res.code !== '10000') return this.$message.error(res.msg)
      this.$message.success('登录成功')
      window.localStorage.setItem('token', res.data.token);
      window.localStorage.setItem('company', JSON.stringify(res.data));
      // 2、通过编程式导航跳转到后台主页, 路由地址为：/home

      this.$router.push('/home')
    },
    async adminRegister(){

      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const { data: res } = await this.$http.post('login/adminRegister', this.registerForm)
      loading.close();
      if (res.code !== '10000') return this.$message.error(res.msg)
      this.$message.success('注册成功')
      window.localStorage.setItem('token', res.data.token);
      window.localStorage.setItem('company', JSON.stringify(res.data));
      // 2、通过编程式导航跳转到后台主页, 路由地址为：/home
      this.$router.push('/home')
    } ,
    async forgetPasswordLogin(){

      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      const { data: res } = await this.$http.post('login/forgetPasswordLogin', this.forgetPasswordForm)
      loading.close();
      console.log(res)
      if (res.code !== '10000') return this.$message.error(res.msg)
      this.$message.success('修改成功')
      window.localStorage.setItem('token', res.data.token);
      window.localStorage.setItem('company', JSON.stringify(res.data));
      // 2、通过编程式导航跳转到后台主页, 路由地址为：/home
      this.$router.push('/home')
    }
  }
}
</script>

<style lang="less" scoped>


.site-wrapper.site-page--login {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(38, 50, 56, .6);
  overflow: hidden;
  &:before {
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    content: "";
    background-image: url("https://wssbw-images.oss-cn-hangzhou.aliyuncs.com/trademark/web/91254b8f-ffc6-4b3e-8c90-932c8c8cebe5.jpeg");
    background-size: cover;
  }
  .site-content__wrapper {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 0;
    margin: 0;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: transparent;
  }
  .site-content {
    min-height: 100%;
    padding: 30px 500px 30px 30px;
  }
  .brand-info {
    margin: 220px 100px 0 90px;
    color: #fff;
  }
  .brand-info__text {
    margin:  0 0 22px 0;
    font-size: 48px;
    font-weight: 400;
    text-transform : uppercase;
  }
  .brand-info__intro {
    margin: 10px 0;
    font-size: 16px;
    line-height: 1.58;
    opacity: .6;
  }
  .login-main {
    position: absolute;
    top: 0;
    right: 0;
    padding: 150px 60px 180px;
    width: 470px;
    min-height: 100%;
    background-color: #fff;
  }
  .login-title {
    font-size: 16px;
  }
  .login-captcha {
    overflow: hidden;
    > img {
      width: 100%;
      cursor: pointer;
    }
  }
  .login-btn-submit {
    width: 100%;
    margin-top: 10px;
  }

  .forgetPassword{
    margin-left: 10px;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/login.vue